import React from 'react';
import {DropdownButton, MenuItem} from 'react-bootstrap';
import {URLs} from '../../common/constants';
import {getPageContext} from "../../common/utils";
import {getItemPrice, formatMoney, formatCredits, getDistributionsNumber} from '../../common/basket';
import QuantityUpdater from '../../containers/common/QuantityUpdater';
import {translate} from '../../i18n/translate.js';

class ItemUnitOrVariants extends React.Component {
    constructor(props) {
        super(props);
        let variations = props.item.variations;
        if (variations && variations.length) {
            let pubSub = props.variantsPubSub;
            let selected = (pubSub||{}).variant;

            this.state = {
				selectedVariation: selected || variations.find(i=>i.quantity > (i.minQuantity||0))
			};

            return;
        } else {
            this.state = {
				selectedVariation: undefined
			};

            return;
        }
    }

    componentWillMount() {
		if (this.props.item.variations && this.props.item.variations.length) {
			let pubSub = this.props.variantsPubSub;
			if (pubSub) {
				pubSub.subscribe(this.variantChangedSubscription);
			}
		}
	}

    componentWillUnmount() {
		if (this.props.item.variations && this.props.item.variations.length) {
			let pubSub = this.props.variantsPubSub;
			if (pubSub) {
				pubSub.unSubscribe(this.variantChangedSubscription);
			}
		}
	}

    variantChangedSubscription = (v) => {
		if (v !== this.state.selectedVariation) {
			this.setState({
				selectedVariation: v
			});
		}
	};

    setSelectedVariation = (selectedVariation) => {
		this.setState({
			selectedVariation: selectedVariation
		});
		let pubSub = this.props.variantsPubSub;
		if (pubSub) {
			pubSub.publish(selectedVariation);
		}
	};

    componentWillReceiveProps(nextProps) {
		const item = nextProps.item;
		if (item.variations && item.variations.length) {
			let selectedVariation = (this.props.variantsPubSub||{}).variant;
			if (!selectedVariation) {
				let variations = item.variations;
				selectedVariation = variations.find(i=>i.quantity > (i.minQuantity || 0));
			}
			if (selectedVariation) {
				// refresh it
				let key = selectedVariation.key;
				selectedVariation = item.variations.find(i=>i.key === key);
			}
			this.setSelectedVariation(selectedVariation);
		}
	}

    getUnit = (item) => {
        const creditItemLabel = this.props.staticData.creditItemLabel;
		const itemPrice = getItemPrice(item, this.props.staticData, this.props.pickupSite);
		const realPrice = getPageContext() === URLs.ACCOUNT ? itemPrice.fullPrice : itemPrice.priceBeforeTax;
		let calcPrice = !item.isCredit?formatMoney(realPrice):!this.props.staticData.isCreditItemAsRegularItem?formatCredits(item.price):formatMoney(item.price);
		if(this.props.isJoinFlow && this.props.isFarmSeasonal && this.props.staticData.hideDeliveryPrice){
			const distributionsNumber = getDistributionsNumber(item, this.props.selectedSchedule);
			calcPrice = this.props.selectedSchedule || item.schedules.length === 1 ? formatMoney(realPrice * (distributionsNumber ? distributionsNumber : 1)) : undefined;
		}
		const price = calcPrice;
		if((this.props.isJoinFlow && price && item.price > 0) || (!this.props.isJoinFlow)){
			return (
				<span className="price-row">
				{price} {item.isCredit && !this.props.staticData.isCreditItemAsRegularItem?' ' + creditItemLabel.toLocaleLowerCase():""}{" / "}
                    {this.props.staticData.showItemPoints && item.points &&
                        <span className="points" name="points">
                            {item.points} p.{" / "}
                        </span>
                    }
                    <span className="unit" name="unit">
                        {this.props.isJoinFlow && item.unitQuantity === 1 ? '' : item.unitQuantity} {item.unit?item.unit.replace("credits",creditItemLabel.toLocaleLowerCase()):item.unit}
                        </span>
			</span>
			)
		}else {
			return <span className="price-row-empty"/>;
		}
	};

    changeVariation = (eventKey) => {
		this.setSelectedVariation(eventKey === "none" ? undefined :
			this.props.item.variations.find(i=>i.key === eventKey));

	};

    getUnitOrVariant = (item) => {
		if (item.variations && item.variations.length) {
			const title =  this.state.selectedVariation ? this.getUnit(this.state.selectedVariation) : translate("Select variation");
			return (
				<DropdownButton name="btnItemVariation" className="item-variation" title={title} onSelect={this.changeVariation} id={"variation-"+item.key}>
					{item.variations.sort((a,b) => a.price > b.price).map(i=> {
						return <MenuItem eventKey={i.key} key={i.key} onClick={this.onContactUsClick}>{this.getUnit(i)}</MenuItem>
					})}
				</DropdownButton>
			);
		} else {
			return this.getUnit(item);
		}
	};

    getQuantityUpdater = (item, details) => {
		return <QuantityUpdater item={this.state.selectedVariation || item}
								details={details}
                                variantSelected ={item.variations && item.variations.length && !this.state.selectedVariation}
								isJoinFlow = {this.props.isJoinFlow}
								selectedSchedule={this.props.selectedSchedule}
								shouldShowQuantityUpdater = {this.props.shouldShowQuantityUpdater}
                                staticData = {this.props.staticData}
		/>
	};

    render() {
        const item = this.props.item;
        const isXs = this.props.clientViewPort && this.props.clientViewPort.isXs;
        //Hide schedules if waitlist on mobile
        const schedules = item.waitList && isXs ? undefined : this.props.schedules;
        return (
            <div>
                {this.props.onlyShowQuantityUpdater ?
                    undefined
                    :
                    <div className="price-wrapper" name="price-wrapper">
                        {this.getUnitOrVariant(item)}
                        {schedules}
                        {item.waitList ?
                            <div className="waitlist">{translate("waitlist only")}</div>
                            : undefined
                        }
                    </div>
                }
                {this.props.hideQuantityUpdater ?
                    undefined
                    :
                    <div className={isXs && this.props.forDetails ? "qty-mobile-wrapper" : ""}>
                        {this.getQuantityUpdater(item, this.props.forDetails)}
                    </div>
                }
            </div>
        )
	}
}

export default ItemUnitOrVariants;



// WEBPACK FOOTER //
// ./src/components/common/ItemUnitOrVariants.js